import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["hideContent", "hideButton"];

    connect() {
    }

    hideContent() {
        this.hideContentTarget.classList.remove('scale-100');
        this.hideContentTarget.classList.add('opacity-0'); // Animate opacity and scale
        setTimeout(() => {
            this.hideContentTarget.classList.add('hidden'); // Hide after transition
        }, 250); // Matches duration-500 from Tailwind CSS
    }
}
